module.exports = __webpack_public_path__ + "static/media/liderazgo.5eaf47ef.jpg";